import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorScreen } from '@datapad/common-controls';
import { useAppContext } from '@datapad/data-model';
import { CampaignsView } from './Components/index.js';
import { MissingCampaign } from './Constants.js';
export function CampaignsApp(props) {
    const { selection: selectionId, changeSelection: changeCampaignSelection } = props;
    const appContext = useAppContext();
    if (appContext.getEffectivePermissionLevel() !== 'game-master') {
        return _jsx(UnauthorizedErrorScreen, {});
    }
    const campaigns = appContext.getAllCampaigns();
    let selectedCampaign;
    if (selectionId === undefined) {
        selectedCampaign = campaigns.length === 0 ? undefined : campaigns[0];
    }
    else {
        selectedCampaign = campaigns.find((c) => c.id === selectionId) ?? MissingCampaign;
    }
    const gmContext = appContext;
    return (_jsx(CampaignsView, { campaigns: campaigns, selection: selectedCampaign, changeSelection: (newSelectedCampaign) => changeCampaignSelection(newSelectedCampaign?.id), addCampaign: gmContext.addCampaign, deleteCampaign: gmContext.deleteCampaign }));
}
function UnauthorizedErrorScreen() {
    return (_jsx(ErrorScreen, { textLines: [
            'Access Denied',
            'The Campaigns app is only accessible to Game Masters.',
            'Please contact your GM if you believe this is an error.',
        ] }));
}
//# sourceMappingURL=CampaignsApp.js.map